import { Component, effect, inject, input, InputSignal, output, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { SelectListItem } from '../../types/select-list-item';
import { InputComponent } from '../input/input.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';

import { ButtonComponent } from "../button/button.component";
import TYPES from '../../constants/types';

@Component({
  selector: 'app-select-list',
  imports: [
    ReactiveFormsModule,
    MatIcon,
    InputComponent,
    TranslatePipe,
    ButtonComponent
],
  templateUrl: './select-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './select-list.component.scss'
})
export class SelectListComponent {

  addingNew: boolean = false;
  control: UntypedFormControl;
  BUTTON_TYPES:any;

  list:InputSignal<SelectListItem[]> = input<SelectListItem[]>([{
    id: null,
    label: '',
    selected: false,
    provider: ''
  }]);
  addItem = output<SelectListItem>();
  deleteItem = output<SelectListItem>();
  itemsSelected:WritableSignal<[]> = signal<[]>([]);

  translateService = inject(TranslateService);

  constructor(){
    this.control = new UntypedFormControl('', [Validators.required]);
    this.BUTTON_TYPES = TYPES.UI.BUTTON;

    effect(
      () => {
        this.list().sort( (a, b) => {
          return this.translateService.instant(a.label).localeCompare(this.translateService.instant(b.label));
        });
      }
    )
  }

  selectItem(item:SelectListItem){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    item.selected = !item.selected;
  }

  addNew(){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    this.addingNew = true;
    setTimeout(() => {
      const el = document.getElementsByClassName('add-new-container')[0];
      el?.scrollIntoView({ behavior: 'smooth' });
    });
  }

  delete(item: SelectListItem){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    this.deleteItem.emit(item);
  }

  cancelAddNew(){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    this.addingNew = false;
  }

  confirmAddNew(){        
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    if(this.control.valid){
      const newSelectedItem: SelectListItem = {
        id: null,
        label: this.control.value.trim(),
        selected: true,
        provider: 'custom'
      };

      this.addItem.emit(newSelectedItem);
      
      this.control.reset();

      this.addingNew = false;
    }else{
      this.control.markAsTouched();
      this.control.markAsDirty();
      this.control.updateValueAndValidity();
    }
  }

}
